// extracted by mini-css-extract-plugin
module.exports = {"wishlistColumnProduct":"WishList-module--wishlist-column-product--1Geut","wishlistIconClose":"WishList-module--wishlistIconClose--20N6Z"};